import * as React from 'react';

export default function SubmittedDeclarationIcon({
  color = 'primary',
}: {
  color: string;
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="64"
      height="64"
      viewBox="0 0 54 104"
    >
      <g transform="translate(-31.696 -17.16)">
        <path
          d="M76.693 17.66H36.839A4.648 4.648 0 0 0 32.2 22.3v4.221a1.36 1.36 0 0 0 1.361 1.361H35.5v68.534h-1.943a1.36 1.36 0 0 0-1.357 1.361V102a4.648 4.648 0 0 0 4.643 4.643h39.85A4.649 4.649 0 0 0 81.338 102v-4.223a1.36 1.36 0 0 0-1.361-1.361h-1.948v-44.4a1.361 1.361 0 0 0-2.722 0v44.4h-3.366a5.525 5.525 0 0 0 .815-2.861V75.4a10.266 10.266 0 0 0-3.708-7.9l-6.508-5.124a.275.275 0 0 1-.109-.226.279.279 0 0 1 .109-.226l6.54-5.151a10.25 10.25 0 0 0 3.676-7.873V30.746a5.525 5.525 0 0 0-.815-2.861h3.366v5.253a1.361 1.361 0 0 0 2.722 0v-5.253h1.948a1.36 1.36 0 0 0 1.361-1.361V22.3a4.649 4.649 0 0 0-4.645-4.64zM38.226 27.885h3.366a5.525 5.525 0 0 0-.815 2.861V48.9a10.262 10.262 0 0 0 3.7 7.894l6.4 5.132a.281.281 0 0 1 .108.226.277.277 0 0 1-.108.223l-6.425 5.153a10.244 10.244 0 0 0-3.675 7.872v18.155a5.525 5.525 0 0 0 .815 2.861h-3.366zM70.034 89.8H43.5V79.138l10.788-6.774a4.69 4.69 0 0 1 4.961 0l10.787 6.774zm8.582 12.2a1.925 1.925 0 0 1-1.923 1.922H36.839A1.924 1.924 0 0 1 34.918 102v-2.86h43.7zM46.36 96.416a2.865 2.865 0 0 1-2.86-2.861v-1.033h26.534v1.033a2.865 2.865 0 0 1-2.861 2.861zM70.034 48.9a7.514 7.514 0 0 1-2.671 5.763l-6.506 5.124a3.01 3.01 0 0 0 0 4.727l6.476 5.1a7.529 7.529 0 0 1 2.7 5.789v.522l-9.34-5.864a7.425 7.425 0 0 0-7.856 0L43.5 75.924V75.4a7.512 7.512 0 0 1 2.682-5.77l6.4-5.135a3.009 3.009 0 0 0 0-4.7L46.2 54.687a7.535 7.535 0 0 1-2.7-5.787V34.5h26.534zm0-18.153v1.033H43.5v-1.034a2.865 2.865 0 0 1 2.861-2.861h20.812a2.865 2.865 0 0 1 2.861 2.861zm8.582-5.583h-43.7V22.3a1.924 1.924 0 0 1 1.922-1.922h39.855a1.925 1.925 0 0 1 1.923 1.922z"
          data-name="Trac\xE9 3691"
          style={{
            fill: color,
            stroke: color,
          }}
        />
        <path
          d="M65.238 33.909a1.36 1.36 0 0 0-1.361 1.361v4.424a1.361 1.361 0 0 0 2.722 0V35.27a1.36 1.36 0 0 0-1.361-1.361z"
          data-name="Trac\xE9 3692"
          style={{
            fill: color,
            stroke: color,
          }}
          transform="translate(11.43 5.863)"
        />
        <circle
          cx={1.887}
          cy={1.887}
          r={1.887}
          data-name="Ellipse 395"
          style={{
            fill: color,
            stroke: color,
          }}
          transform="translate(46.375 80.364)"
        />
        <circle
          cx={1.887}
          cy={1.887}
          r={1.887}
          data-name="Ellipse 396"
          style={{
            fill: color,
            stroke: color,
          }}
          transform="translate(53.32 74.611)"
        />
        <circle
          cx={1.887}
          cy={1.887}
          r={1.887}
          data-name="Ellipse 397"
          style={{
            fill: color,
            stroke: color,
          }}
          transform="translate(54.001 83.06)"
        />
      </g>
    </svg>
  );
}
